module.exports = __webpack_public_path__ + "static/media/easPowered.ae8b2bf5.svg";